import { qs, qsa, triggerAPI } from './util';
import { emitSegment } from './segment/emitSegment';
import lj from './lumberjack';
import { emitGA } from './marketing';

const parentWrapper = qs('#SME'),
  cardWrapper = qs('#gift-box .cards', parentWrapper),
  hoverBox = qs('#gift-box .hover-box', parentWrapper),
  cards = qsa('#gift-box .cards .card', parentWrapper),
  cardModal = qs('.modal-effect', parentWrapper),
  submitEmail = qs('.box-wrapper .email .submit', parentWrapper),
  email = document.forms['sme-form'].email,
  emailWrapper = qs('.box-wrapper .email', parentWrapper);

let hasError = false,
  isFormSubmit = false,
  hubspotPayload = '',
  fbBase = 'https://www.facebook.com/sharer/sharer.php?u=',
  twitterBase = 'https://twitter.com/share?url=',
  linkedinBase = 'http://www.linkedin.com/shareArticle?mini=true&url=',
  pageURL = encodeURIComponent(location.host + '/YouAreAweSME');

qs('a.rzp-logo').setAttribute('href', '#razorpay');

$('#razorpay-logo-footer')[0].setAttribute(
  'src',
  '/assets/razorpay-logo-white.svg'
);

function toggleScreen() {
  if (innerWidth < 769) {
    cardWrapper.classList.remove('nomob');
    cardWrapper.classList.add('mob');
  } else {
    cardWrapper.classList.add('nomob');
    cardWrapper.classList.remove('mob');
  }
}

window.addEventListener('resize', function() {
  toggleScreen();
});

function getHost() {
  if (location.host === 'razorpay.com') {
    return 'https://dashboard.razorpay.com';
  } else if (location.host === 'betasite.razorpay.com') {
    return 'https://beta-dashboard.stage.razorpay.in';
  } else {
    return 'https://beta-dashboard.stage.razorpay.in';
  }
}

function getEmail() {
  return sessionStorage.getItem('email');
}

cardModal.addEventListener('click', () => {
  cards.map(elm => elm.classList.remove('active-card'));
  cardModal.style.display = 'none';
  cardWrapper.classList.remove('add-margin');
  qs('#gift-box .cards .card.bottom', parentWrapper).classList.remove(
    'adjust-bottom-card-desktop'
  );
  qs('#gift-box .cards .card.right', parentWrapper).classList.remove(
    'adjust-right-card-desktop'
  );
  qs('.cards .card.middle .message', cardWrapper).style.display = 'none';
});

cards.forEach(el => {
  el.addEventListener('click', e => {
    if (cardWrapper.classList.contains('nomob')) {
      cards.map(elm => elm.classList.remove('active-card'));
      !e.currentTarget.classList.contains('no-effect') &&
        e.currentTarget.classList.add('active-card');
      cardModal.style.display = 'block';
      if (e.currentTarget.classList.contains('top')) {
        cardWrapper.classList.add('add-margin');
      }
      if (e.currentTarget.classList.contains('middle')) {
        qs('#gift-box .cards .card.bottom', parentWrapper).classList.add(
          'adjust-bottom-card-desktop'
        );
      }
      if (e.currentTarget.classList.contains('bottom')) {
        qs('#gift-box .cards .card.right', parentWrapper).classList.add(
          'adjust-right-card-desktop'
        );
      }
    }
  });
});

window.addEventListener('scroll', () => {
  if (!isFormSubmit) {
    if (window.scrollY > 500) {
      qs('.sticky-header', parentWrapper).style.display = 'block';
    } else {
      qs('.sticky-header', parentWrapper).style.display = 'none';
    }
  }
});

qs('#gift-box .sticky-header').addEventListener('click', () => {
  window.scrollTo(0, 0);
});

qs(`.cards .card.top .card-footer .sign-up`, cardWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Card 1 click: Razorpay Payments', {
      location: 'first-fold',
      targetPage: `${getHost()}/signup?email=${btoa(
        getEmail()
      )}&coupon_code=PGSMEDAY21`
    });
    lj.pushEvents({
      event_name: 'Card 1 click: Razorpay Payments',
      event_type: 'click',
      properties: {
        location: 'first-fold'
      }
    });
    emitGA(
      'Razorpay Payments - Card Click',
      'WSME - Razorpay Payments',
      'Click'
    );
    open(
      `${getHost()}/signup?email=${btoa(getEmail())}&coupon_code=PGSMEDAY21`
    );
  }
);

qs(
  `.cards .card.nomob.left .card-footer .sign-up`,
  cardWrapper
).addEventListener('click', e => {
  trackSegment(e, 'CTA 3 click: Razorpay Payout', {
    location: 'first-fold',
    targetPage: 'https://x.razorpay.com/auth/signup?r=worldmsmeday'
  });
  lj.pushEvents({
    event_name: 'CTA 3 click: Razorpay Payout',
    event_type: 'click',
    properties: {
      location: 'first-fold'
    }
  });
  emitGA('Razorpay Payout - Card Click', 'WSME - Razorpay Payout', 'Click');
  open('https://x.razorpay.com/auth/signup?r=worldmsmeday');
});

qs(`.cards .card.mob.left .card-footer .sign-up`, cardWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'CTA 3 click: Razorpay Payout', {
      location: 'first-fold',
      targetPage: 'https://x.razorpay.com/auth/signup?r=worldmsmeday'
    });
    lj.pushEvents({
      event_name: 'CTA 3 click: Razorpay Payout',
      event_type: 'click',
      properties: {
        location: 'first-fold'
      }
    });
    emitGA('Razorpay Payout - Card Click', 'WSME - Razorpay Payout', 'Click');
    open('https://x.razorpay.com/auth/signup?r=worldmsmeday');
  }
);

qs(`.cards .card.bottom .card-footer .sign-up`, cardWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Card 4 click: Razorpay Instant Settlement', {
      location: 'first-fold',
      targetPage: `${getHost()}/signup?email=${btoa(
        getEmail()
      )}&coupon_code=ISSMEDAY21`
    });
    lj.pushEvents({
      event_name: 'Card 4 click: Razorpay Instant Settlement',
      event_type: 'click',
      properties: {
        location: 'first-fold'
      }
    });
    emitGA(
      'Razorpay Instant Settlement - Card Click',
      'WSME - Razorpay Instant Settlement',
      'Click'
    );
    open(
      `${getHost()}/signup?email=${btoa(getEmail())}&coupon_code=ISSMEDAY21`
    );
  }
);

qs(`.cards .card.right .card-footer .sign-up`, cardWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'CTA 2 click: Razorpay Payroll', {
      location: 'first-fold',
      targetPage: 'https://payroll.razorpay.com/signup?r=smeday21'
    });
    lj.pushEvents({
      event_name: 'CTA 2 click: Razorpay Payroll',
      event_type: 'click',
      properties: {
        location: 'first-fold'
      }
    });
    emitGA('Razorpay Payroll - Card Click', 'WSME - Razorpay Payroll', 'Click');
    open('https://payroll.razorpay.com/signup?r=smeday21');
  }
);

qs(
  `.cards .card.middle .card-footer .sign-up.email-me`,
  cardWrapper
).addEventListener('click', e => {
  trackSegment(e, 'CTA 6 Click : Email me', {
    location: 'first-fold',
    targetPage:
      'sending email hubspot form id: 2fcffa89-a55e-4b8e-bab6-54349da0eb4f'
  });
  lj.pushEvents({
    event_name: 'CTA 6 Click : Email me',
    event_type: 'click',
    properties: {
      location: 'first-fold'
    }
  });
  emitGA('Email Me - CTA Click', 'WSME - Email Me', 'Click');

  let emailMehubspotPayload = {
    fields: [
      {
        name: 'email',
        value: getEmail()
      }
    ],
    context: {
      pageUri: `www.${window.location.hostname}/${window.location.pathname}`,
      pageName: 'Razorpay #YouAreAweSME'
    },
    legalConsentOptions: {
      consent: {
        // Include this object when GDPR options are enabled
        consentToProcess: true,
        text:
          'I agree to allow Razorpay to store and process my personal data.',
        communications: [
          {
            value: true,
            subscriptionTypeId: 6760497,
            text: 'I agree to receive marketing communications from Razorpay.'
          }
        ]
      }
    }
  };

  triggerAPI(
    'https://api.hsforms.com/submissions/v3/integration/submit/5558946/2fcffa89-a55e-4b8e-bab6-54349da0eb4f',
    'POST',
    response => {
      let res = JSON.parse(response);
      if (!res.error) {
        innerWidth < 769 &&
          alert('Thank you! Your guidebooks will be emailed to you.');
        qs('.cards .card.middle .message', cardWrapper).style.display = 'block';
        setTimeout(() => {
          qs('.cards .card.middle .message', cardWrapper).style.display =
            'none';
        }, 7000);
      } else {
        console.log('Error while processing your request', res.error);
      }
    },
    emailMehubspotPayload
  );
});

function validateEmail(field) {
  let regExp = /^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/;
  if (!regExp.test(field.value)) {
    hasError = true;
    field.classList.add('field-error');
    emailWrapper.classList.add('has-error');
    return false;
  } else if (field.value.length === 0) {
    hasError = true;
    field.classList.add('field-error');
    emailWrapper.classList.add('has-error');
    return false;
  } else {
    hasError = false;
    field.classList.remove('field-error');
    emailWrapper.classList.remove('has-error');
    return true;
  }
}

function handleSubmit(e) {
  validateEmail(email);
  if (hasError) {
    emailWrapper.classList.add('error-shake');
    setTimeout(() => {
      emailWrapper.classList.remove('error-shake');
    }, 1000);
  } else {
    emailWrapper.classList.remove('error-shake');
    isFormSubmit = true;
    hubspotPayload = {
      fields: [
        {
          name: 'email',
          value: `${email.value}`
        }
      ],
      context: {
        pageUri: `www.${window.location.hostname}/${window.location.pathname}`,
        pageName: 'Razorpay #YouAreAweSME'
      },
      legalConsentOptions: {
        consent: {
          // Include this object when GDPR options are enabled
          consentToProcess: true,
          text:
            'I agree to allow Razorpay to store and process my personal data.',
          communications: [
            {
              value: true,
              subscriptionTypeId: 6760497,
              text: 'I agree to receive marketing communications from Razorpay.'
            }
          ]
        }
      }
    };
    emailWrapper.classList.add('submited');
    trackSegment(e, 'Email entry field', {
      location: 'first-fold',
      enteredEmail: getEmail(),
      hubspotFormId: '135d1eeb-9bc7-41f0-b9d1-378b0d14d43d'
    });
    lj.pushEvents({
      event_name: 'Email entry field',
      event_type: 'click',
      properties: {
        location: 'first-fold'
      }
    });
    emitGA('Email Submit', 'WSME - Email Field', 'Click');
    triggerAPI(
      'https://api.hsforms.com/submissions/v3/integration/submit/5558946/135d1eeb-9bc7-41f0-b9d1-378b0d14d43d',
      'POST',
      response => {
        let res = JSON.parse(response);
        if (res.status === 'error') {
          email.classList.add('field-error');
          emailWrapper.classList.remove('submited');
          emailWrapper.classList.add('error-shake');
          emailWrapper.classList.add('has-error');
          setTimeout(() => {
            emailWrapper.classList.remove('error-shake');
          }, 1000);
        } else {
          qs('#gift-box', parentWrapper).classList.add('box-open');
          qs('.social-share', parentWrapper).style.display = 'flex';
          sessionStorage.setItem('email', email.value);
          emailWrapper.classList.remove('has-error');
          email.classList.remove('field-error');
          emailWrapper.classList.remove('error-shake');
          hoverBox.classList.add('fade-out');
          emailWrapper.classList.remove('submited');
          setTimeout(() => {
            hoverBox.style.display = 'none';
          }, 1000);
          setTimeout(() => {
            cardWrapper.classList.add('fade-in');
            cardWrapper.style.opacity = '1';
            cardWrapper.style.visibility = 'visible';
          }, 1000);
          emailWrapper.classList.add('fade-out');
          setTimeout(() => {
            emailWrapper.style.display = 'none';
          }, 1000);
          qs('.gift-box .heading.pre-email').style.display = 'none';
          qs('.gift-box .heading.post-email').style.display = 'block';
          setTimeout(() => {
            cards.forEach(el => {
              cards.map(elm => elm.classList.remove('open-sessime'));
            });
          }, 1300);
        }
      },
      hubspotPayload
    );
  }
}

submitEmail.addEventListener('click', handleSubmit);

window.addEventListener('keydown', e => {
  if (e.key === 'Enter' && !hasError) {
    e.preventDefault();
    handleSubmit(e);
    return false;
  }
});

email.addEventListener('keyup', e => {
  validateEmail(e.target);
});

var animation = bodymovin.loadAnimation({
  container: hoverBox,
  path:
    'https://cdn.razorpay.com/static/assets/razorpay.com/sme/animateBox.json',
  renderer: 'svg',
  loop: true,
  autoplay: true,
  name: 'SME Gift Box'
});

setInterval(() => {
  animation.stop();
  animation.play();
}, 9000);

function trackSegment(e, eventName, otherProperties) {
  let properties = Object.assign({
    properties: {
      anonymousId: localStorage.getItem('ajs_anonymous_id'),
      url: location.href,
      section: e.currentTarget.classList,
      otherProperties
    }
  });
  emitSegment(eventName, properties);
}

qs('.social-share .social-icons .icon.in', parentWrapper).addEventListener(
  'click',
  e => {
    let shareTitle = encodeURIComponent(
        'An awesome gift awaits you, because #YouAreAweSME '
      ),
      shareMessage = encodeURIComponent(
        ' Here’s to the MSMEs that are making it big! Today’s your day! Check out this gift by Razorpay to give your business a boost this #WorldMSMEDay, simply because @YouAreAweSME'
      );
    trackSegment(e, 'LinkedIn', {
      location: 'first-fold'
    });
    lj.pushEvents({
      event_name: 'LinkedIn',
      event_type: 'click',
      properties: {
        location: 'first-fold'
      }
    });
    emitGA('Linkedin Share - CTA Click', 'WSME - Linkedin Share', 'Click');
    open(
      linkedinBase + pageURL + '&title=' + shareTitle + shareMessage,
      'linkedin-share',
      'width=550,height=235'
    );
  }
);

qs('.social-share .social-icons .icon.twtr', parentWrapper).addEventListener(
  'click',
  e => {
    let shareTitle = encodeURIComponent(
        'An awesome gift awaits you, because #YouAreAweSME '
      ),
      shareMessage = encodeURIComponent(
        ' Here’s to the MSMEs that are making it big! Today’s your day! Check out this gift by Razorpay to give your business a boost this #WorldMSMEDay, simply because @YouAreAweSME'
      );
    trackSegment(e, 'Twitter', {
      location: 'first-fold'
    });
    lj.pushEvents({
      event_name: 'Twitter',
      event_type: 'click',
      properties: {
        location: 'first-fold'
      }
    });
    emitGA('Twitter Share - CTA Click', 'WSME - Twitter Share', 'Click');
    open(
      twitterBase + pageURL + '&text=' + shareTitle + shareMessage,
      'twitter-share',
      'width=550,height=235'
    );
  }
);

qs('.social-share .social-icons .icon.fb', parentWrapper).addEventListener(
  'click',
  e => {
    let shareTitle = encodeURIComponent(
        'An awesome gift awaits you, because #YouAreAweSME '
      ),
      shareMessage = encodeURIComponent(
        ' Here’s to the MSMEs that are making it big! Today’s your day! Check out this gift by Razorpay to give your business a boost this #WorldMSMEDay, simply because @YouAreAweSME'
      );
    trackSegment(e, 'Facebook', {
      location: 'first-fold'
    });
    lj.pushEvents({
      event_name: 'Facebook',
      event_type: 'click',
      properties: {
        location: 'first-fold'
      }
    });
    emitGA('Facebook Share - CTA Click', 'WSME - Facebook Share', 'Click');
    open(
      fbBase + pageURL + '&quote=' + shareTitle + shareMessage,
      'facebook-share',
      'width=550,height=235'
    );
  }
);

qs('.social-share .tnc.nomob a', parentWrapper).addEventListener('click', e => {
  e.preventDefault();
  trackSegment(e, 'CTA 5 Click : T&C page', {
    location: 'first-fold'
  });
  lj.pushEvents({
    event_name: 'Facebook',
    event_type: 'click',
    properties: {
      location: 'first-fold'
    }
  });
  emitGA('TnC Page - CTA Click', 'WSME - TnC Page', 'Click');
  open('https://lp.razorpay.com/links/youareawesme');
});

qs('.social-share .tnc.mob a', parentWrapper).addEventListener('click', e => {
  e.preventDefault();
  trackSegment(e, 'CTA 5 Click : T&C page', {
    location: 'first-fold'
  });
  lj.pushEvents({
    event_name: 'Facebook',
    event_type: 'click',
    properties: {
      location: 'first-fold'
    }
  });
  emitGA('TnC Page - CTA Click', 'WSME - TnC Page', 'Click');
  open('https://lp.razorpay.com/links/youareawesme');
});

qs('#trust .extra-info a.note', parentWrapper).addEventListener('click', e => {
  e.preventDefault();
  trackSegment(e, 'Sign up CTA Click', {
    location: 'second-fold'
  });
  lj.pushEvents({
    event_name: 'Sign up CTA Click',
    event_type: 'click',
    properties: {
      location: 'second-fold'
    }
  });
  emitGA('Signup CTA - CTA Click', 'WSME - Signup CTA', 'Click');
  open(`${getHost()}/signup?email=${btoa(getEmail())}&coupon_code=PGSMEDAY21`);
});

qs('#products .products .product.pg a', parentWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Click 1: Payment Gateway', {
      location: 'third-fold'
    });
    lj.pushEvents({
      event_name: 'Click 1: Payment Gateway',
      event_type: 'click',
      properties: {
        location: 'third-fold'
      }
    });
    emitGA('PG - CTA Click', 'WSME - Payment Gateway', 'Click');
  }
);

qs('#products .products .product.pl a', parentWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Click 2: Payment Links', {
      location: 'third-fold'
    });
    lj.pushEvents({
      event_name: 'Click 2: Payment Links',
      event_type: 'click',
      properties: {
        location: 'third-fold'
      }
    });
    emitGA('PL - CTA Click', 'WSME - Payment Links', 'Click');
  }
);

qs('#products .products .product.pp a', parentWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Click 3: Payment Pages', {
      location: 'third-fold'
    });
    lj.pushEvents({
      event_name: 'Click 3: Payment Pages',
      event_type: 'click',
      properties: {
        location: 'third-fold'
      }
    });
    emitGA('PP - CTA Click', 'WSME - Payment Pages', 'Click');
  }
);

qs('#products .products .product.pb a', parentWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Click 4: Payment Buttons', {
      location: 'third-fold'
    });
    lj.pushEvents({
      event_name: 'Click 4: Payment Buttons',
      event_type: 'click',
      properties: {
        location: 'third-fold'
      }
    });
    emitGA('PB - CTA Click', 'WSME - Payment Buttons', 'Click');
  }
);

qs('#products .products .product.is a', parentWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Click 4: Instant Settlements', {
      location: 'third-fold'
    });
    lj.pushEvents({
      event_name: 'Click 4: Instant Settlements',
      event_type: 'click',
      properties: {
        location: 'third-fold'
      }
    });
    emitGA('IS - CTA Click', 'WSME - Instant Settlements', 'Click');
  }
);

qs('#products .products .product.p a', parentWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Click 5: Payroll', {
      location: 'third-fold'
    });
    lj.pushEvents({
      event_name: 'Click 5: Payroll',
      event_type: 'click',
      properties: {
        location: 'third-fold'
      }
    });
    emitGA('Payroll - CTA Click', 'WSME - Payroll', 'Click');
  }
);

qs('#products .products .product.po a', parentWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Click 6: Payouts', {
      location: 'third-fold'
    });
    lj.pushEvents({
      event_name: 'Click 6: Payouts',
      event_type: 'click',
      properties: {
        location: 'third-fold'
      }
    });
    emitGA('Payouts - CTA Click', 'WSME - Payouts', 'Click');
  }
);

qs('#products .products .product.em a', parentWrapper).addEventListener(
  'click',
  e => {
    trackSegment(e, 'Click 7: Explore more', {
      location: 'third-fold'
    });
    lj.pushEvents({
      event_name: 'Click 7: Explore more',
      event_type: 'click',
      properties: {
        location: 'third-fold'
      }
    });
    emitGA('Explore more - CTA Click', 'WSME - Explore more', 'Click');
  }
);
